import { render, staticRenderFns } from "./list-deposit.vue?vue&type=template&id=8a96ab8e&scoped=true"
import script from "./list-deposit.vue?vue&type=script&lang=js"
export * from "./list-deposit.vue?vue&type=script&lang=js"
import style0 from "./list-deposit.vue?vue&type=style&index=0&id=8a96ab8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a96ab8e",
  null
  
)

export default component.exports